'use client';

import { useEffect } from 'react';
import { pushGtmEvent } from '@/lib/analytics/gtm';
import { GTM_EVENTS } from '@/lib/analytics/gtmEvents';

export function PageViewTracker({ category }: { category: string }) {
  useEffect(() => {
    pushGtmEvent(GTM_EVENTS.VIEW_SERVICE_PAGE, { category });
  }, [category]);

  return null;
}
